import React from 'react';
import { Empty } from 'antd';
import EmployeeCensusPage from '../../pages/EmployeeCensusPage';

/**
 * Who is arriving: the census page's Active Recruitment table, covering the
 * last 30 days and the next 30.
 *
 * Its own window, fixed at 30 days either side of today, so the page's date
 * range does not apply here -- which is why it is a tab of its own rather
 * than sharing one with headcount.
 */
export default function RecruitmentTab({ teamId, team }) {
  if (!teamId) {
    return <Empty description="Select a team" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <EmployeeCensusPage embedded teamId={teamId} sections={['recruitment']} />
    </>
  );
}
